if (!customElements.get("image-gallery")) {
  class ImageGallery extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(event) {
      const target = event.target.closest("[js-filter]");
      if (!target) return;

      event.preventDefault();

      this.filterButtons.forEach((b) => b.classList.remove("is-active"));
      target.classList.add("is-active");

      const filter = target.getAttribute("js-filter");

      this.images.forEach((image) => {
        image.classList.toggle(
          "hidden",
          filter != this.allString &&
            image.getAttribute("js-gallery-image") != filter
        );
      });

      this.lightBox.destroy();
      this.lightBox.init();
    }

    connectedCallback() {
      this.lightBox = new PhotoSwipeLightbox({
        gallery: '#' + this.getAttribute("js-gallery-id"),
        children: "a.gallery__image:not(.hidden)",
        pswpModule: PhotoSwipe,
      });

      this.lightBox.init();

      this.filterButtons = this.querySelectorAll("[js-filter]");
      this.images = this.querySelectorAll("[js-gallery-image]");
      this.allString = this.getAttribute("js-all");

      this.addEventListener("click", this.handleClick.bind(this));
    }
  }

  customElements.define("image-gallery", ImageGallery);
}
